import { gql } from "apollo-boost";

export const GET_CONSULTORY_MONTHLY_CLOSURES = gql`
  query getConsultoryMonthlyClosure(
    $where: DailyClosingWhereInput
    $relations: [String]
  ) {
    getConsultoryMonthlyClosure(where: $where, relations: $relations) {
      id
      consultingFee
      status {
        id
        name
      }
      month
      year
      date
      periodStartDate
      periodEndDate
    }
  }
`;
